export default "__VITE_ASSET__Bl1AOlgf__"